import "./RequestQuote.module.css";
import Header from "@/reusable_sections/Header";
import EnquiryIntro from "./sections/EnquiryIntro";
import OrderEnquiry from "./sections/OrderEnquiry";
import Footer from "@/reusable_sections/Footer";
export default function RequestQuotePage() {
  return <div>
      <Header />
      <EnquiryIntro />
      <OrderEnquiry />
      <Footer />
    </div>;
}